import { render, staticRenderFns } from "./BannersWelcome.vue?vue&type=template&id=373b0588&scoped=true&"
import script from "./BannersWelcome.vue?vue&type=script&lang=js&"
export * from "./BannersWelcome.vue?vue&type=script&lang=js&"
import style0 from "./BannersWelcome.vue?vue&type=style&index=0&id=373b0588&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b0588",
  null
  
)

component.options.__file = "BannersWelcome.vue"
export default component.exports